import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "children"];
import UITextToolbarButton from 'rich-text-lib/components/editor/UITextToolbarButton';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const RTEToolbarButton = props => {
  return /*#__PURE__*/_jsx(View, {
    marginBlock: "0",
    marginInline: "25",
    children: /*#__PURE__*/_jsx(UITextToolbarButton, Object.assign({}, props, {
      display: "inline-flex",
      alignItems: "center",
      minInlineSize: "27px",
      justifyContent: "center"
    }))
  });
};
export const RTEToolbarLoadingButton = _ref => {
  let {
      loading,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, {
    marginBlock: "0",
    marginInline: "25",
    children: /*#__PURE__*/_jsx(UITextToolbarButton, Object.assign({}, props, {
      children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : children
    }))
  });
};